import { Color } from './color.model';
import { Answer } from './qa.model';

export class Answers {
    public postalCode: string;
    public selectedColor: Color;
    public selectedAnswers: Answer[] = [];
    constructor() {
        this.postalCode = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/models/answers.model.ts